import { AppDateFormat, AppTimeFormat } from '../entities/team-settings';

const DATE_FORMAT_MAP: Record<AppDateFormat, string> = {
  mdyl: 'MMMM dd, YYYY',
  'mdy/': 'MM/dd/YYYY',
  'dmy/': 'dd/MM/YYYY',
  'dmy.': 'dd.MM.YYYY',
  'dmy-': 'dd-MM-YYYY',
  'ymd-': 'YYYY-MM-dd',
};

export function appDateToAngular(from: AppDateFormat): string {
  return DATE_FORMAT_MAP[from] ?? '';
}

const TIME_FORMAT_MAP: Record<AppTimeFormat, string> = {
  '12s': 'h:mm:ss a',
  '12sz': 'h:mm:ss a z',
  '12': 'h:mm a',
  '12z': 'h:mm a z',
  '24s': 'HH:mm:ss',
  '24sz': 'HH:mm:ss z',
  '24': 'HH:mm',
  '24z': 'HH:mm z',
};

export function appTimeToAngular(from: AppTimeFormat): string {
  return TIME_FORMAT_MAP[from] ?? '';
}
